// Client-side match highlighting for search snippets/descriptions. The
// legacy app does the same (no server-side markup) but builds the RegExp
// from the raw query with no escaping — a latent bug for queries containing
// regex metacharacters. This version escapes first.
export function highlightMatch(text, query) {
  if (!text) return "";
  if (!query) return text;
  const escaped = query.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  return text.replace(new RegExp(`(${escaped})`, "gi"), '<span style="color:#f04e23;font-weight:600">$1</span>');
}
